var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgInProgressIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 60,
    height: 61,
    viewBox: "0 0 60 61",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_324_71431)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M30.0279 60.5C13.47 60.5 0 47.03 0 30.4721C0 13.9464 13.47 0.5 30.0279 0.5C46.5536 0.5 60 13.9464 60 30.4721C60 47.03 46.5536 60.5 30.0279 60.5ZM30.0279 2.64286C14.6507 2.64286 2.14286 15.1271 2.14286 30.4721C2.14286 45.8493 14.6507 58.3571 30.0279 58.3571C45.3729 58.3571 57.8571 45.8493 57.8571 30.4721C57.8571 15.1271 45.3729 2.64286 30.0279 2.64286Z",
    fill: "#409089"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.0018 45.6521L14.8496 30.4999L30.0018 15.3456L45.1539 30.4999L30.0018 45.6521ZM17.8796 30.4999L30.0018 42.6221L42.1218 30.4999L30.0018 18.3778L17.8796 30.4999Z",
    fill: "#409089"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.9277 24.0714H31.0706V32.6429H28.9277V24.0714ZM28.9277 34.7857H31.0706V36.9286H28.9277V34.7857Z",
    fill: "#409089"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_324_71431"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 60,
    height: 60,
    fill: "white",
    transform: "translate(0 0.5)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgInProgressIcon);
export default __webpack_public_path__ + "static/media/in-progress-icon.3b337dc0da3ed834af937b2e46d463a8.svg";
export { ForwardRef as ReactComponent };